"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.secondaryStyle = exports.primaryStyle = exports.hoverStyles = void 0;

var _designTokens = require("@decisiv/design-tokens");

var _color = _interopRequireDefault(require("@decisiv/design-tokens/lib/color"));

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _styledComponents = require("styled-components");

var _styledTheming = _interopRequireDefault(require("styled-theming"));

var _ConfigProvider = require("../../providers/ConfigProvider");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var hoverStyles = (0, _styledComponents.css)(["color:", ";background-color:", ";border:", " solid ", ";svg{color:", ";}"], (0, _toColorString.default)(_color.default.base.snowWhite), (0, _toColorString.default)(_color.default.interaction.indianOcean), (0, _rem.default)(1), (0, _toColorString.default)(_color.default.interaction.indianOcean), (0, _toColorString.default)(_color.default.base.snowWhite));
exports.hoverStyles = hoverStyles;
var primaryStyle = (0, _styledComponents.css)(["border:", " solid ", ";&:hover{", ";}&:disabled:disabled{background-color:transparent;color:", ";}"], (0, _rem.default)(1), (0, _toColorString.default)(_color.default.base.quarterMoon), hoverStyles, (0, _toColorString.default)(_color.default.opacity.charcoal40));
exports.primaryStyle = primaryStyle;
var secondaryStyle = (0, _styledComponents.css)(["height:", ";"], (0, _rem.default)(_designTokens.spacing.base * 2.4));
exports.secondaryStyle = secondaryStyle;

var kindStyles = _styledTheming.default.variants(_ConfigProvider.themeKeys.mode, 'kind', {
  primary: {
    light: primaryStyle,
    dark: primaryStyle
  },
  secondary: {
    light: secondaryStyle,
    right: secondaryStyle
  }
});

var _default = kindStyles;
exports.default = _default;